const PHONE_RE = /\D/g;

// Reshapes uploaded-XML application data into the body createLoanApiSlice expects.
// Shared by any page that may need to lazily create the real Encompass loan record
// (currently the Dashboard, on first XML consumption, and Qualify/AURA's credit
// re-issue step as a fallback if the loan wasn't already created).
export function normalizeXmlForCreateLoan(xmlData) {
	if (!xmlData) return xmlData;
	const normalizedApplications = (xmlData.applications || []).map((app) => {
		const borrower = app.borrower || {};
		const coborrower = app.coBorrower || app.coborrower || {};
		const residences = (app.residences || []).map((r, i) => ({ ...r, id: `Residence/${i}` }));
		return {
			borrower: {
				...borrower,
				homePhoneNumber:
					(borrower.homePhoneNumber || "").replace(PHONE_RE, "") || borrower.homePhoneNumber,
				mailingAddressSameAsPresentIndicator: false,
			},
			coBorrower: {
				hmdaNoCoApplicantIndicator: false,
				...coborrower,
				mailingAddressSameAsPresentIndicator: false,
			},
			assets: app.assets,
			otherAssets: app.otherAssets,
			liabilities: app.liabilities,
			otherLiabilities: app.otherLiabilities,
			employment: app.employment,
			otherIncomeSources: app.otherIncomeSources,
			propertyUsageType: app.propertyUsageType,
			reoProperties: app.reoProperties,
			residences,
		};
	});
	return { ...xmlData, applications: normalizedApplications };
}

// A loanGuid is "real" (Encompass-issued) once it matches a UUID — the fallback
// placeholder used before that ("LN-2024-00847") never does.
export const isRealLoanGuid = (guid) =>
	Boolean(guid) && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(guid);
